import { CONTENT_PROPERTIES, fetchCmpObjectsByType } from 'personalization-lib/api/clients/cmpApiClient';
import { PERSONALIZATION_STATUS } from 'personalization-lib/constants/status';
import { notHasProperty, propertyEquals, propertyNotEquals } from 'personalization-lib/utils/assetData/cmp';
import { WEBSITE_PAGES_URL } from 'personalization-lib/constants/urls';
import { fetchContentById } from 'personalization-lib/api/clients/contentApiClient';
export const fetchWebsitePage = id => fetchContentById({
  url: WEBSITE_PAGES_URL,
  id
});

// Filters that always apply, regardless of picker mode.
export const WP_BASE_FILTERS = [propertyEquals(CONTENT_PROPERTIES.AUDIENCE_ACCESS, 'PUBLIC')];

// Filters that restrict results to assets eligible for personalization
// (excluding personalized assets, language variants, and A/B test assets).
// Dropped when the picker is fetching all assets.
export const WP_ELIGIBLE_FOR_PERSONALIZATION_FILTERS = [notHasProperty(CONTENT_PROPERTIES.VARIATION), notHasProperty(CONTENT_PROPERTIES.AB_STATUS), notHasProperty(CONTENT_PROPERTIES.PERSONALIZATION_STRATEGY_ID), propertyNotEquals(CONTENT_PROPERTIES.PERSONALIZATION_VARIANT_STATUS, PERSONALIZATION_STATUS.VARIANT)];
export const WP_FILTERS = [...WP_ELIGIBLE_FOR_PERSONALIZATION_FILTERS, ...WP_BASE_FILTERS];
export const fetchWebsitePagesOptions = (paginationParams, includeAllAssets = false) => fetchCmpObjectsByType(Object.assign({
  objectType: 'SITE_PAGE',
  filters: includeAllAssets ? WP_BASE_FILTERS : WP_FILTERS
}, paginationParams)).then(cmpPaginatedSearch => ({
  total: cmpPaginatedSearch.total,
  results: cmpPaginatedSearch.results.map(asset => ({
    text: asset.name,
    value: asset.id.toString(),
    screenshot: asset.imgSrc
  })),
  offset: cmpPaginatedSearch.offset
}));